// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeprecatedStylesContainer__overflowHidden__uqtp9{overflow:hidden}
`, "",{"version":3,"sources":["webpack://./src/js/apps/components/common/Layout/DeprecatedStylesContainer/DeprecatedStylesContainer.scss"],"names":[],"mappings":"AACA,kDACI,eAAgB","sourcesContent":["\n.overflowHidden {\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overflowHidden": `DeprecatedStylesContainer__overflowHidden__uqtp9`
};
export default ___CSS_LOADER_EXPORT___;
